const $ = jQuery.noConflict();
import Global from '../shared/global';
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

'use strict';

const Animatios = {
	slFade: '.fade-in',
	heroSecReveal: '.reveal-hero',
	attrFadeDelay: 'data-fade-delay',

	init: function() {
		gsap.registerPlugin(ScrollTrigger);

		const hasAny =
			document.querySelector(this.slFade) ||
			document.querySelector(this.heroSecReveal);

		if (!hasAny) return;

		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			gsap.set(this.slFade, {autoAlpha: 1, clearProps: 'all'});
			gsap.set(this.heroSecReveal, {autoAlpha: 1, clearProps: 'all'});
			return;
		}

		// FOUC prevent — hide both fade and hero before animations start
		gsap.set([this.slFade, this.heroSecReveal], {autoAlpha: 0});

		this.mm = ScrollTrigger.matchMedia({
			'(min-width: 0px)': () => {
				this.fadeAll();
				this.heroReveal();
			}
		});

		window.addEventListener('load', ()=>ScrollTrigger.refresh());
	},

	fadeAll: function() {
		const ww = Global?.varsWindowWidth || window.innerWidth;
		const defaultStart = ww <= 1024 ? 'top bottom-=80' : 'top bottom-=120';

		gsap.utils.toArray(this.slFade).forEach((el)=>{
			const $el = $(el);
			const delay = parseFloat($el.attr(this.attrFadeDelay) || '0');

			// keep the tween paused; start it manually when ScrollTrigger enters
			const tween = gsap.fromTo(
				el,
				{autoAlpha: 0, y: 16},
				{
					autoAlpha: 1,
					y: 0,
					duration: 1.2,
					ease: 'power2.out',
					overwrite: 'auto',
					paused: true,
					force3D: false,
					onStart: () => { // for smooth animation
						el.style.willChange = 'opacity, transform';
					},
					onComplete: () => {
						el.style.willChange = '';
						el.style.backfaceVisibility = '';
						// remove GPU and subpixel rounding after animation
						gsap.set(el, {clearProps: 'transform'});
					}
				}
			);

			ScrollTrigger.create({
				trigger: el,
				start: defaultStart,
				once: true,
				invalidateOnRefresh: true,
				onEnter: () => gsap.delayedCall(delay, () => tween.play())
			});
		});
	},

	heroReveal: function() {
		const wrap = document.querySelector(this.heroSecReveal);
		const img = wrap?.querySelector('.reveal-hero-image');
		if (!wrap || !img) return;

		// setup
		gsap.set(img, {clipPath: 'inset(25% round 30px)', willChange: 'transform'});

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: wrap,
				start: 'top 70%',
				toggleActions: 'play none none none',
				invalidateOnRefresh: true
			},
			defaults: {ease: 'power2.out'}
		});

		// first, show the wrap instantly (we hid it to avoid a flash before JS runs)
		tl.to(wrap, {autoAlpha: 1, duration: 0.01});

		// then reveal the image + a subtle offset
		tl.to(img, {clipPath: 'inset(0% round 30px)', duration: 1.2});
		tl.to(img, {y: 12, duration: 1.2}, 0.2);
	}
};

export default Animatios;